import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_LOGIN_FLAG,
  TWO_FACTOR_REQUIRED,
} from "./actionTypes";

const initialState = {
  errorMsg: "",
  loading: false,
  error: false,
  twoFactorRequired: false,
  user: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: false,
        twoFactorRequired: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        user: action.payload,
        twoFactorRequired: false,
      };
    case LOGOUT_USER:
      return { ...state, isUserLogout: false };
    case LOGOUT_USER_SUCCESS:
      return { ...initialState, isUserLogout: true };
    case API_ERROR:
      return {
        ...state,
        errorMsg: action.payload.data,
        loading: false,
        error: true,
        isUserLogout: false,
        twoFactorRequired: action.payload.twoFactorRequired,
      };
    case RESET_LOGIN_FLAG:
      return {
        ...initialState,
      };
    case TWO_FACTOR_REQUIRED:
      return {
        ...state,
        twoFactorRequired: true,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};

export default login;